var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-icon loading-animated",class:'img-' + _vm.size},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 130.2 130.2"}},[_c('circle',{staticClass:"path circle",attrs:{"cx":"65.1","cy":"65.1","r":"62.1","fill":"none","stroke-width":"6","stroke-miterlimit":"10"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }